import { auth } from '../firebase'; // Import auth for user authentication

// Define API_BASE_URL (ensure this matches your environment setup)
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3800';

/**
 * Fetches the application configuration from the backend.
 * @returns {Promise<object>} - A promise that resolves with the configuration data (e.g., statuses).
 * @throws {Error} - Throws an error if the request fails, the user is not authenticated, or the response is not successful.
 */
export const getAppConfig = async () => {
    const user = auth.currentUser;
    if (!user) {
        throw new Error("User not authenticated.");
    }

    try {
        const idToken = await user.getIdToken();
        const url = `${API_BASE_URL}/config/app`; // Endpoint for app config

        console.log("API Request GET to /config/app");

        const response = await fetch(url, {
            method: 'GET', // Use GET method
            headers: {
                'Authorization': `Bearer ${idToken}`,
                'Content-Type': 'application/json', // Although GET, specifying content type is good practice
            },
            // No body for GET request
        });

        const responseData = await response.json();
        console.log("API Response from /config/app:", responseData);

        if (!response.ok) {
            throw new Error(responseData.message || `HTTP error! status: ${response.status}`);
        }
        if (responseData.status !== 'success') {
            throw new Error(responseData.message || 'Failed to retrieve app configuration.');
        }

        // Return the data part containing the configuration (e.g., statuses)
        return responseData.data || {};

    } catch (error) {
        console.error('Error fetching app configuration:', error);
        throw error; // Re-throw the error for the caller to handle
    }
};
